export default __webpack_public_path__ + "static/media/au_redb.392cbc25.jpg";